import {$} from '../jquery-definition.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import 'jquery-match-height';

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

$( function() {
	$( '.equal-height' ).matchHeight();
} );

$( '.image-carousel' ).each( function() {
	var $this = $( this );

	var autoPlay = $this.attr( 'data-autoplay' );

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: true,
		prevNextButtons: true,
		selectedAttraction: 0.01,
		friction: 0.2,
		wrapAround: true,
		contain: true,
		autoPlay: autoPlay,
		pauseAutoPlayOnHover: false
	} );

	if ( $this.hasClass( 'story-mode' ) ) {
		$( '.flickity-page-dots .dot' ).append( '<span class="progress-bar"></span>' );
		var time = 5000;
		var start = null;

		$carousel.on( 'change.flickity', function( event, index ) {
			start = window.performance.now();
		} );

		function step( timestamp ) {
			if ( start === null ) {
				start = timestamp;
			}
			var elapsed = timestamp - start;
			var percent = Math.min( elapsed / time * 100, 100 );
			$carousel.find( '.flickity-page-dots .dot .progress-bar' ).css( { width: '0%' } );
			$carousel.find( '.flickity-page-dots .dot.is-selected .progress-bar' ).css( { width: percent + "%" } );
			if ( elapsed > time + 100 ) {
				$carousel.flickity( 'next', true );
				start = timestamp;
			}
			window.requestAnimationFrame( step );
		}

		window.requestAnimationFrame( step );
	}

	var $nextButton = $this.find( '.flickity-prev-next-button.next' );
	var $previousButton = $this.find( '.flickity-prev-next-button.previous' );

	$carousel.on( 'staticClick.flickity', function( clickEvent ) {
		if ( clickEvent.clientX < $( window ).width() / 2 ) {
			$carousel.flickity( 'previous', true );
		} else {
			$carousel.flickity( 'next', true );
		}
	} );
} );
